export const BILLING_COMPANY_ROUTE = "/billing-company";
